function getCookieDomain() {
  const hostname = window.location.hostname;
  if (hostname === 'localhost' || /^\d/.test(hostname)) return undefined;
  return `.${hostname}`;
}

export { getCookieDomain };
